import Google from "@/pixels/providers/google";

const context = {
  mutation: {
    payload: {
      params: {
        mje: "mensaje-0"
      }
    }
  },
  state: {
    paquetesBeneficios: {
      caracteristicas: {}
    },
    oferta: {},
    paso3: {}
  }
};

window.gtag = jest.fn();

describe("Google config", () => {
  beforeEach(() => {
    jest.spyOn(Google, "enable");
    jest.spyOn(Google, "init");
    jest.spyOn(Google, "wait");
    jest.spyOn(Google, "_enviarSnippet");
    jest.spyOn(Google, "paso1");
    jest.spyOn(Google, "gracias");
    jest.spyOn(Google, "mensaje");

    window.google_trackConversion = () => ({});
    window.gtag = () => ({});
    window.dataLayer = { push: args => args };
  });

  it("configuracion exportada por defecto para Google", () => {
    expect(Google).toBeDefined();
    expect(Google).not.toBeNull();
  });

  it("Validamos si se llaman las funciones de Googlee", () => {
    Google.enable();
    const enableMock = jest.spyOn(Google, "enable");
    expect(enableMock).toHaveBeenCalledTimes(1);

    Google.init();
    const initMock = jest.spyOn(Google, "init");
    expect(initMock).toHaveBeenCalledTimes(1);

    Google.wait();
    const waitMock = jest.spyOn(Google, "wait");
    expect(waitMock).toHaveBeenCalledTimes(1);

    Google._enviarSnippet();
    const _enviarSnippetMock = jest.spyOn(Google, "_enviarSnippet");
    expect(_enviarSnippetMock).toHaveBeenCalledTimes(1);

    Google.paso1();
    const paso1Mock = jest.spyOn(Google, "paso1");
    expect(paso1Mock).toHaveBeenCalledTimes(1);

    Google.gracias(context);
    const graciasMock = jest.spyOn(Google, "gracias");
    expect(graciasMock).toHaveBeenCalledTimes(1);
  });

  it("0", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: 0
          }
        }
      }
    };

    Google.mensaje(context);
    const mensajeMock = jest.spyOn(Google, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(1);
  });

  it("msj 1", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: 1
          }
        }
      }
    };

    Google.mensaje(context);
    const mensajeMock = jest.spyOn(Google, "mensaje");
    expect(mensajeMock).toHaveBeenCalledTimes(2);
  });
});